import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const PlaceholderIcon = (props: PosIconProps) => {
  const fill = props.fill ?? 'currentColor';
  return (
    <SvgWrapper aria-label="placeholder-icon" {...props} viewBox="0 0 13 13">
      <path
        d="M6 11.6V12.8H3.2V11.6H6ZM1.2 7.2V9.6H0V7.2H1.2ZM12.8 4V6.4H11.6V4H12.8ZM7.6 0.8V2H5.2V0.8H7.6Z"
        fill={fill}
      />
      <path d="M9.6 11.6V12.8H6.8V11.6H9.6Z" fill={fill} />
      <path
        d="M1.2 10.4C1.2 11.0627 1.73726 11.6 2.4 11.6V12.8L2.27656 12.7969C1.04933 12.7347 0.0653002 11.7507 0.003125 10.5234L0 10.4H1.2Z"
        fill={fill}
      />
      <path d="M1.2 4V6.4H0V4H1.2Z" fill={fill} />
      <path
        d="M10.4 11.6V12.8C11.7255 12.8 12.8 11.7255 12.8 10.4H11.6C11.6 11.0627 11.0627 11.6 10.4 11.6Z"
        fill={fill}
      />
      <path d="M12.8 7.2V9.6H11.6V7.2H12.8Z" fill={fill} />
      <path
        d="M7.39995 5.4C7.39995 4.84772 6.95223 4.4 6.39995 4.4C6.05718 4.4 5.75469 4.57246 5.57451 4.83534C5.38717 5.10867 5.13132 5.4 4.79995 5.4C4.46857 5.4 4.19164 5.12636 4.28074 4.80719C4.53953 3.88011 5.39031 3.2 6.39995 3.2C7.61497 3.2 8.59995 4.18497 8.59995 5.4C8.59995 6.40672 7.92293 7.25262 6.99995 7.51406V8C6.99995 8.33137 6.73132 8.6 6.39995 8.6C6.06857 8.6 5.79995 8.33137 5.79995 8V7C5.79995 6.66863 6.06857 6.4 6.39995 6.4C6.95223 6.4 7.39995 5.95228 7.39995 5.4Z"
        fill={fill}
      />
      <path
        d="M7.19994 10C7.19994 10.4418 6.84177 10.8 6.39995 10.8C5.95812 10.8 5.59995 10.4418 5.59995 10C5.59995 9.55817 5.95812 9.2 6.39995 9.2C6.84177 9.2 7.19994 9.55817 7.19994 10Z"
        fill={fill}
      />
      <path
        d="M3.8 0.600045C3.8 0.268674 3.53137 0 3.2 0C2.86863 0 2.6 0.26863 2.6 0.600001V0.8H2.4C1.07452 0.8 0 1.87452 0 3.2H1.2C1.2 2.53726 1.73726 2 2.4 2H2.6V2.6C2.6 2.93137 2.86863 3.2 3.2 3.2C3.53137 3.2 3.8 2.93137 3.8 2.6V2H4.4V0.8H3.8V0.600045Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2 0.6V0.8H10.4C11.7255 0.8 12.8 1.87452 12.8 3.2H11.6C11.6 2.53726 11.0627 2 10.4 2H10.2V2.6C10.2 2.93137 9.93137 3.2 9.6 3.2C9.26863 3.2 9 2.93137 9 2.6V2H8.4V0.8H9V0.60009C9 0.268719 9.26863 0 9.6 0C9.93137 0 10.2 0.268629 10.2 0.6Z"
        fill={fill}
      />
    </SvgWrapper>
  );
};
